import request from "@/utils/request";

// 获取药剂分类树
export function queryMedicamentTree(data) {
  return request({
    url: "/drugCategory/selectTree",
    method: "post",
    data,
  });
}

// 药剂树新增
export function insertMedicamentTree(data) {
  return request({
    url: "/drugCategory/save",
    method: "post",
    data,
  });
}

// 药剂树修改
export function updateMedicamentTree(data) {
  return request({
    url: "/drugCategory/update",
    method: "post",
    data,
  });
}

// 药剂树删除
export function deleteMedicamentTree(id) {
  return request({
    url: `/drugCategory/delete/${id}`,
    method: "delete",
  });
}

// 药剂树详情
export function queryMedicamentTreeById(id) {
  return request({
    url: `/drugCategory/${id}`,
    method: "get",
  });
}

// 药剂分页查询
export function queryMedicamentPage(data) {
  return request({
    url: "/drugInfo/page",
    method: "post",
    data,
  });
}

// 查询药剂详情
export function queryMedicamentById(id) {
  return request({
    url: `/drugInfo/${id}`,
    method: "get",
  });
}

//药剂新增
export function insertMedicament(data) {
  return request({
    url: "/drugInfo/save",
    method: "post",
    data,
  });
}

//药剂编辑
export function updateMedicament(data) {
  return request({
    url: "/drugInfo/update",
    method: "post",
    data,
  });
}

// 药剂删除
export function deleteMedicament(id) {
  return request({
    url: `/drugInfo/delete/${id}`,
    method: "delete",
  });
}
